export default {
  '0504f1bc-5727-4c11-943b-21ae32d664fb': 'apple',
  'dfeffbaa-53a1-41e6-b8cf-e145b8dcd772': 'windows',
  '45d3ae2e-ddfe-411b-9119-ac4a0f8ac823': 'linux',
  'a10f539f-21a0-4151-9674-a7eed02840ad': 'apple',
  'cf42490e-2c88-42f0-9832-09ed1f67949c': 'android',
};
